/** @jsx h */
const Radiobox = ({ option, filterName, handleChange, pluginNamespace }) => {
  return (
    <li
      className={`centers__list-item centers__list-item--filter ${
        option.selected ? 'centers__list-item--is-active' : ''
      }`}
    >
      <label
        className={`search-section__radiobox ${
          filterName !== 'center' && 'search-section__radiobox--no-grid'
        }`}
        htmlFor={`${filterName}-${option.value}`}
      >
        <input
          id={`${filterName}-${option.value}`}
          className="sr-only"
          type="radio"
          name={`${pluginNamespace}[filter][${filterName}]`}
          value={`${filterName}:${option.value}`}
          data-label={
            filterName === 'center'
              ? `${filterName}-${option.value}`
              : `${filterName}-${option.label}`
          }
          onChange={handleChange}
          checked={option.selected}
        />
        {filterName === 'center' && <span>{option.value}</span>}
        <p>
          {option.label} ({option.documentCount})
        </p>
      </label>
    </li>
  );
};

export default Radiobox;
